import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import '../style/ContactPage.css';

function ContactIcon({ type }) {
  if (type === 'email') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 6H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 2v.5l-8 5l-8-5V8h16zM4 16V10.8l8 5l8-5V16H4z" />
      </svg>
    );
  }

  if (type === 'phone') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.2c1.1.4 2.3.6 3.6.6a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.8 21 3 13.2 3 4a1 1 0 0 1 1-1h3.4a1 1 0 0 1 1 1c0 1.3.2 2.5.6 3.6a1 1 0 0 1-.2 1l-2.2 2.2z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2a7 7 0 0 0-7 7c0 4.8 6 12.2 6.3 12.5a1 1 0 0 0 1.4 0C13 21.2 19 13.8 19 9a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
    </svg>
  );
}

export default function ContactPage() {
  return (
    <div className="ContactPage">
      <Navbar />

      <section className="ContactPage-hero" id="contact-hero" aria-label="Get in touch hero">
        <img
          className="ContactPage-heroImage"
          src={`${process.env.PUBLIC_URL}/image/nane.jpeg`}
          alt="Contact Abstan Logistics"
          loading="eager"
        />
        <div className="ContactPage-heroOverlay" />
        <div className="ContactPage-heroContent">
          <h1>Get In Touch</h1>
        </div>
      </section>

      <main className="ContactPage-main" aria-label="Contact page content">
        <div className="ContactPage-inner">
          <section className="ContactPage-mapWrap" aria-label="Location and contact details">
            <div className="ContactPage-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.586034109181!2d39.28314957524332!3d-6.820096493177668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c4b79eb635923%3A0xc9e126667bbee70d!2sHarbour%20View%20Suites!5e0!3m2!1sen!2stz!4v1774032174113!5m2!1sen!2stz"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Abstan Logistics location map"
              />
            </div>

            <aside className="ContactPage-details" aria-label="Contact details">
              <h2>Contact Us</h2>
              <div className="ContactPage-detailRow">
                <span className="ContactPage-detailIcon" aria-hidden="true">
                  <ContactIcon type="email" />
                </span>
                <p>info@abstan.co.tz</p>
              </div>

              <div className="ContactPage-detailRow">
                <span className="ContactPage-detailIcon" aria-hidden="true">
                  <ContactIcon type="phone" />
                </span>
                <p>+255748400444</p>
              </div>

              <div className="ContactPage-detailRow ContactPage-detailRowStart">
                <span className="ContactPage-detailIcon" aria-hidden="true">
                  <ContactIcon type="location" />
                </span>
                <p>
                  Harbour View Towers
                  <br />
                  4th Floor, Room No. 416,
                  <br />
                  Plot No.2317/108 and 2318/108,
                  <br />
                  Samora Avenue,
                  <br />
                  Dar es Salaam - Tanzania
                </p>
              </div>
            </aside>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
